import React, { useState, useEffect, useRef } from "react";

import "react-toastify/dist/ReactToastify.css";
import PricingPlans from "../../subscription/PricingPlans";
import SubscriptionAdvantagesView from "../../subscription/SubscriptionAdvantagesView";
import { toast } from "react-toastify";
import { subscriptionService } from "../../../_services";

var Modal = require("react-bootstrap-modal");

import SubscriptionPage from "../../subscription/SubscriptionPlans";

export const SubscriptionPlans = ({
  onNext,
  onPrev,
  formData,
  setFormData,
  className,
  save,
  updating,
}) => {


  const [stepForm, setStepForm] = useState({
  });


  const valueRef = useRef(formData);

  const elementRef = useRef(null);

  
  useEffect(() => {
    valueRef.current = {...formData}
  }, [formData])
  
  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;
    
    const observer = new MutationObserver(() => {
      if (element.classList.contains('tw-hidden')) {
        handleComponentDisappear();
      }
    });
    
    observer.observe(element, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    return () => observer.disconnect();
  }, []);

  const handleComponentDisappear = () => {
    setFormData(valueRef.current);
  };

  const handleStep = (tag, value) => {
    setStepForm({ ...stepForm, [tag]: value });
    valueRef.current = { ...formData, ...stepForm, [tag]: value };
  };
  const handleNextStep = (e) => {
    e.preventDefault();
    const subscription = subscriptionInfo
    if(subscription && (subscription.status == 'Active')) {
     
      valueRef.current = {...formData, ...stepForm}
      setFormData({ ...formData, ...stepForm });
      setTimeout(() => {
        save(stepForm);
        onNext();
      }, 0); 
    } else {
      toast.error("Please activate a subscription plan to list your property")
    }

  };

  const [subscriptionInfo, setSubscriptionInfo] = useState(null)

  return (
    <form onSubmit={handleNextStep}>
      <div className={className}  ref={elementRef}>
        <div className=" my-3 tw-min-h-[60vh]">
          <h4 className="mb-5 tw-flex tw-justify-start tw-items-center">
            <span className="tw-bg-[#23426e] tw-mr-2 tw-flex tw-justify-center tw-items-center  tw-h-10 tw-w-10 tw-text-white  tw-rounded-full">
              10
            </span>{" "}
            Subscription Plans
          </h4>
          <SubscriptionPage setSubscriptionInfo={setSubscriptionInfo}/>
        </div>
        <div>
          <button
            onClick={onPrev}
            type="button"
            className="btn btn-secondary mx-2  tw-mb-2"
          >
            Prev
          </button>

          <button
            type="submit"
            disabled={updating}
            className="btn btn-secondary tw-mb-2"
          >
            {updating ? "Updating ..." : "Save & Next"}
          </button>
        </div>
      </div>
    </form>
  );
};